"use client"

import * as React from "react"
import Image from "next/image"
import useEmblaCarousel from "embla-carousel-react"
import Autoplay from "embla-carousel-autoplay"
import Link from "next/link"

interface HeroSlideProps {
  slides: { url: string, path: string }[];
}


export default function HeroSlide({ slides }: HeroSlideProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 2500 })]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  React.useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    onSelect();
    return () => {
      if (emblaApi && emblaApi.off) {
        emblaApi.off("select", onSelect);
      }
    };
  }, [emblaApi]);

  return (
    <section className="h-auto xl:h-[660px] relative overflow-hidden">
      <div ref={emblaRef} className="overflow-hidden">
        <div className="flex">
          {slides.map((slide, idx) => (
            <div className="min-w-0 shrink-0 grow-0 basis-full" key={idx}>
              <Link href={slide?.path || '/'}>
                <Image
                  src={`${slide.url}?h=360`}
                  alt="Hero Banner"
                  width={320}
                  height={320}
                  className="w-full h-full object-cover"
                  fetchPriority={idx === 0 ? "high" : "auto"}
                  loading={idx === 0 ? "eager" : "lazy"}
                />

              </Link>
            </div>
          ))}
        </div>
      </div>
      {/* For mobile devices (default) */}
      <div className="flex justify-center items-center space-x-2 pb-2 mt-4 absolute left-1/2 bottom-2 -translate-x-1/2 md:bottom-6">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`w-3 h-3 rounded-full inline-block transition-colors ${selectedIndex === idx ? "bg-[#222]" : "bg-[#e0e0e0]"}`}
            onClick={() => emblaApi && emblaApi.scrollTo(idx)}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  )
}

